import type { AnswersMap } from '@/types';

const CHANNEL_NAME = 'turniej-progress';

export interface ProgressBroadcast {
  currentIndex: number;
  answers: AnswersMap;
}

export function broadcastProgress(payload: ProgressBroadcast): void {
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(payload);
    channel.close();
  } catch {
    // BroadcastChannel not supported — server poll handles sync.
  }
}

export function subscribeProgress(
  onMessage: (payload: ProgressBroadcast) => void,
): () => void {
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event: MessageEvent<ProgressBroadcast>) => {
      if (event.data && typeof event.data.currentIndex === 'number') {
        onMessage(event.data);
      }
    };
    return () => channel.close();
  } catch {
    return () => undefined;
  }
}
